var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInviteFriendsIcon = function SvgInviteFriendsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.35166,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9177 8.55334C17.8069 8.13708 18.5825 7.99997 19.7858 7.99998C22.865 8.01218 25.1441 10.4961 25.1441 13.6602C25.1441 16.0752 23.7363 18.4082 21.1139 20.664C19.7374 21.8481 17.98 23.0199 16.7214 23.6433L16.0013 24L15.2811 23.6433C14.0225 23.0199 12.2651 21.8481 10.8886 20.664C8.26626 18.4082 6.8584 16.0752 6.8584 13.6602C6.8584 10.4623 9.11622 7.99997 12.2232 7.99997C13.3833 7.99997 14.1987 8.15004 15.1051 8.57883C15.4207 8.72811 15.7172 8.90519 15.9929 9.10958C16.2797 8.89305 16.5886 8.70745 16.9177 8.55334Z",
    fill: "#5656FC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInviteFriendsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inviteFriendsIcon.917dfd80.svg";
export { ForwardRef as ReactComponent };